import { render } from "./ProductDetail_asso.vue?vue&type=template&id=7121ee20&scoped=true"
import script from "./ProductDetail_asso.vue?vue&type=script&lang=js"
export * from "./ProductDetail_asso.vue?vue&type=script&lang=js"

import "./ProductDetail_asso.vue?vue&type=style&index=0&id=7121ee20&scoped=true&lang=css"
import "./ProductDetail_asso.vue?vue&type=style&index=1&id=7121ee20&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7121ee20"]])

export default __exports__